import { createReducer } from '@reduxjs/toolkit';
import { resetClient, hideSubmitButton, setSubmitInProgress, setSubmissionSuccessful, addNewLoopEntry, deleteLoopEntry, setUnsupportedField, toggleInteractiveClient } from "../../actions/client";

// expected unsupported field schema
// {
//   type: type,
//   guid: guid,
//   parentGuid: parentGuid,
//   rowGuid: rowGuid,
//   value: value ? value : '',
// }

export const initialClientSettingsState = {
  interactiveClient: false,
  activeRowGuid: '',
  unsupportedField: null,
  showingUnsupportedField: false,
  hideSubmitButton: false,
  addNewLoopEntry: false,
  submitInProgress: false,
  submissionSuccessful: false,
  disableRequired: false,
  ignoreConditions: false,
  allowLoopEdits: false,
  disableReadOnlyFields: false,
  prePopulationLimit: 180,
  // default to allowing a lot, but still limit
  referenceDataEndpoint: `/reference_data_column_caches.json?reference_data_id=`
};
export const clientSettingsReducerConfig = {
  [resetClient]: (state, action) => {
    return {
      ...state,
      // leave other settings intact
      activeRowGuid: '',
      unsupportedField: null,
      showingUnsupportedField: false,
      addNewLoopEntry: false,
      hideSubmitButton: false,
      submissionSuccessful: false
    };
  },
  [hideSubmitButton]: (state, action) => {
    return {
      ...state,
      hideSubmitButton: action.payload
    };
  },
  [setSubmitInProgress]: (state, action) => {
    return {
      ...state,
      submitInProgress: action.payload
    };
  },
  [setSubmissionSuccessful]: (state, action) => {
    return {
      ...state,
      submissionSuccessful: action.payload
    };
  },
  [addNewLoopEntry]: (state, action) => {
    const {
      addNewLoopEntry = false,
      activeRowGuid = ''
    } = action.payload;
    return {
      ...state,
      activeRowGuid,
      addNewLoopEntry,
      hideSubmitButton: !!activeRowGuid
    };
  },
  [deleteLoopEntry]: state => {
    return {
      ...state,
      activeRowGuid: '',
      addNewLoopEntry: false,
      hideSubmitButton: false
    };
  },
  [setUnsupportedField]: (state, action) => {
    return {
      ...state,
      unsupportedField: action.payload,
      showingUnsupportedField: action.payload ? true : false
    };
  },
  [toggleInteractiveClient]: (state, action) => {
    return {
      ...state,
      interactiveClient: action.payload
    };
  }
};
export const clientSettingsReducer = createReducer(initialClientSettingsState, clientSettingsReducerConfig);